import { FieldHookConfig, useField } from "formik";
import React from "react";
import { Col, Form, FormControl, Row } from "react-bootstrap";
import { MultiEditField } from "../../../models";

export interface OdsMultiInputProps {
    label: string;
}

export const OdsMultiInput: React.FC<OdsMultiInputProps & FieldHookConfig<MultiEditField<string | undefined | null>>> = ({
    label,
    ...props
}) => {
    const [field, meta, helpers] = useField(props);

    const doValueChanged = (selected: any) => {
        helpers.setValue(new MultiEditField(selected.target.value, true), true);
    }

    const doUpdateChanged = (update: React.ChangeEvent<HTMLInputElement>) => {
        helpers.setValue(new MultiEditField(field.value?.value, !(field.value?.update ?? true)), true);
    }

    return (
        <Row>
            <Col md="auto">
                <Form.Group controlId={`${field.name}Update`}>
                    <Form.Label>Update&nbsp;&nbsp;</Form.Label>
                    <Form.Check
                        name={`${field.name}Update`}
                        type="switch"
                        placeholder={`Update ${label}`}
                        checked={field.value?.update ?? false}
                        onChange={doUpdateChanged}
                        onBlur={field.onBlur}
                        isInvalid={!!meta.touched && !!meta.error}
                    />
                    <Form.Control.Feedback type="invalid">
                        {meta.error}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col>
                <Form.Group controlId={field.name}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                        name={field.name}
                        type="text"
                        placeholder={label}
                        value={field.value?.value ?? ""}
                        onChange={doValueChanged}
                        onBlur={field.onBlur}
                        isInvalid={!!meta.touched && !!meta.error}
                        disabled={props.disabled}
                    />
                    <Form.Control.Feedback type="invalid">
                        {meta.error}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
    )
};
